import React from "react";
import { toast } from "react-toastify";

/**
 * Catches an error thrown while drawing its children — one malformed post used
 * to blank the whole page with nothing on screen to say why. Shows a toast and
 * a Try again button instead; Try again redraws (and re-runs `onReset`).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error(`${this.props.name || "Page"} render error::`, error, info?.componentStack);
    toast.error(`${this.props.name || "This page"} hit an error and could not be shown.`, { toastId: `boundary-${this.props.name}` });
  }

  handleReset = () => {
    this.setState({ failed: false });
    this.props.onReset?.();
  };

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="text-center p-5">
        <p className="mb-3">{this.props.name || "This page"} could not be shown.</p>
        <button type="button" className="btn btn-dark btn-sm" onClick={this.handleReset}>Try again</button>
      </div>
    );
  }
}

export default ErrorBoundary;
